window.theme = window.theme || {};

/* Config */
theme.config = function() {
  theme.selectors = {
    $plus: '.add',
    $minus: '.sub',
    $checkoutBtn: '.addtocart1',
    $removeBtn: '.remove_mix',
    $radio_selection:'.radio_selection',
    $adjust:'.adjust',
    $month:'.colsublist .delivery-select'

  }
}

/*  Init */
theme.init = function() {

  var mixBasket = [],parent='';
  var val = 5;
  theme.config();
  theme.activeMonth(theme.selectors.$month,val,mixBasket);
  theme.plusminus(theme.selectors.$adjust,val,mixBasket);
  theme.addItem(theme.selectors.$plus,val,mixBasket);
  theme.removeItem(theme.selectors.$minus,val,mixBasket);
  theme.itemCollect(mixBasket,parent);
  theme.final(theme.selectors.$checkoutBtn,val,mixBasket);

};
theme.activeMonth = function(trigger,val,mixBasket) {  
  $('body').on('click', trigger,function(){
    var parent = $(this).parents('.subsavmain').data('section-id');    
    $(this).parents('.delivery').find('.delivery-select').removeClass('active_month');
//     console.log('******'+$(this).parents('.product-page').find('.product_title').text());
    $(this).addClass('active_month');
    theme.itemCollect(mixBasket,parent);
  });
}
theme.final = function(trigger,val,mixBasket) {
  
//   function addItem(id_inner,qty,selling_plan){
// // alert(id_inner,'dddd',qty,'qty',selling_plan);
//     data = {
//       "id": id_inner,
//       "quantity": qty,
//       "selling_plan": selling_plan
//     }
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: data,
//       dataType: 'json',
//       async: false,
//       success: function(data) {        
//         $.get( "/cart?view=minicart", function(data) {
//           $('.mini-cart').html(data);
//           $(".mini-cart").removeClass("loded");
//         });
//         $.getJSON('/cart.js', function(cart){
//           var cartCount = cart.item_count ;          
//           $('#CartCount,#CartCount__mb,#mini_cnt').html("<span class=''>" + cartCount + "</span>");
//         });
//         $('.mini-cart').addClass('active');
//         $('.overlay').addClass('active');
//       }
//     }).done(function( data ) {
//       $.get( "/cart?view=minicart", function(data) {
//         $('.mini-cart').html(data);
//         $(".mini-cart").removeClass("loded");
//       });
//       $.getJSON('/cart.js', function(cart){
//           var cartCount = cart.item_count ;          
//           $('#CartCount,#CartCount__mb,#mini_cnt').html("<span class=''>" + cartCount + "</span>");
//         });
//         $('.mini-cart').addClass('active');
//         $('.overlay').addClass('active');
//     });
//   }
  function addsubItem(datav) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: datav,
      dataType: 'json',
      async: false
    });
  }
  $('body').on('click', trigger,function(){    
    var JSONObj = [];
    var dataID = [];
    var hasClass= 'false';
    var has_qty = '';
    var parent = $(this).parents('.subsavmain').data('section-id');
    $('.subsavmain[data-section-id="'+parent+'"]').find('.active-added').each(function(){            
       var active_month = $(this).parents('.choose-towel').next('.colsublist').find('.active_month').attr('data-index');
      var id_inner = Number($(this).attr('data-variant-id')),
          has_qty = Number($(this).find('.count').val()),
          qty = Number($(this).find('.count').val()),          
          selling_plan = Number($(this).attr('data-selling-'+active_month));      	
//       addItem(id_inner,qty,selling_plan);      
      if(active_month > 0){
      dataID.push({
        "id": id_inner,
        "quantity": qty,
        "selling_plan": selling_plan
      });
      }else{
        dataID.push({
          "id": id_inner,
          "quantity": qty,          
        });
      }      
    });              
      var dataID = dataID.reverse();    
    if($('.subsavmain[data-section-id="'+parent+'"]').hasClass('HasQuantity')){      
      var addpro = $.each(dataID, function( i, v ) {
        addsubItem(v);
      });
      dataID.push(addpro);

      $.when.apply($, dataID).done(function(){
        $.get( "/cart?view=minicart", function(data) {
          $('.mini-cart').html(data);
          $(".mini-cart").removeClass("loded");
        });
        $.getJSON('/cart.js', function(cart){
          var cartCount = cart.item_count ;          
          $('#CartCount,#CartCount__mb,#mini_cnt').html("<span class=''>" + cartCount + "</span>");
        });
        $('.mini-cart').addClass('active');
        $('.overlay').addClass('active');
      }); 
    }
//     jQuery.post('/cart/add.js', {
//       items: JSONObj,
//       success: function(item) {
//         console.log('done');
//         $('.mini-cart').addClass('active');
//         $('.overlay').addClass('active');
//       }
//     });

    setTimeout(function(){
//       window.location.href = '/checkout'; 
    },900);


//     $.each( JSONObj, function(i,v) {
//       setTimeout(function(){
//         var data = {
//           "id": v.id,
//           "quantity": v.quantity,
//           "selling_plan": v.selling_plan
//         }
//         addItem(data);
//       },500);
//     });

  });
  
}
theme.addItem = function(trigger,val,mixBasket) {
  $('body').on('click', trigger,function(){
    console.log(trigger,'+++');
    var productMax = val,
        thisVariantDataID = $(this).attr('data-variant-id');
    var parent = $(this).parents('.subsavmain').data('section-id');
    $(this).closest('.subscribe-pro').addClass('active-added');	
    mixBasket.push(thisVariantDataID);
    theme.itemCollect(mixBasket,parent);
  });
}
theme.removeItem = function(trigger,val,mixBasket) {
  $('body').on('click', trigger,function(){
    var productMax = val,
        thisVariantDataID = $(this).attr('data-variant-id'),
        idPosition = mixBasket.indexOf(thisVariantDataID);
    var parent = $(this).parents('.subsavmain').data('section-id');
    if(parseInt($(this).closest('.subscribe-pro').find('.count').val()) == 0){
      $(this).closest('.subscribe-pro').removeClass('active-added');      
    }
    mixBasket.splice(idPosition, 1); 
    theme.itemCollect(mixBasket,parent);
  });
}
theme.itemCollect = function(mixBasket,parent) {
  var mpr = $('.subsavmain[data-section-id="'+parent+'"]');
  var mf =	$(mpr).find('.subscribe-pro').attr('data-money-format');
  var discount = $('.delivery-schedule .addtocart1,.delivery-schedulew .addtocart1').attr('data-discount');
  if(mixBasket.length < 2){
    $(mpr).find('.set').text('(set of 2)');
  } else{
    $(mpr).find('.set').text('(sets of 2)');
  }
  var totalquantity = 0;
  $(mpr).find('.active-added').each(function(){
    var no = parseInt($(this).find('.count').val());
    totalquantity = totalquantity + no;
  });
  if(totalquantity >=1 ){
  	$(mpr).addClass('HasQuantity');
  }else{
  $(mpr).removeClass('HasQuantity');
  }
  
  $(mpr).find('.colsublist .count').text(totalquantity);
  var total = 0;
  var per_total = 0;  
  $(mpr).find('.subscribe-pro.active-added').each(function(i,v){
    
    var qty = $(this).find('.count').val();
//     console.log(qty);        
    total = total + Number($(this).attr('data-price') * qty);
    console.log(total);
    $(mpr).attr('data-quantity',total);
  });
  var hasget = $(mpr).find('.active_month').attr('data-index');
  if(hasget >=1 ){
    var per_total = total - (discount/100 * total) ;
    $(mpr).find('.del-price').show();
    $(mpr).find('.del-price').html(Shopify.formatMoney(total ,mf));
    $(mpr).find('.total_pricesubscribe').html(Shopify.formatMoney(per_total,mf));
  }else{
    $(mpr).find('.del-price').hide();
    var per_total = total;
    $(mpr).find('.total_pricesubscribe').html(Shopify.formatMoney(per_total,mf));
  }    
}
theme.plusminus = function(trigger,val,mixBasket) {
  $('body').on('click', trigger,function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    //     if( $(this).hasClass('sub')) {
    //       return false;
    //     }
    if($(this).hasClass('add')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip < 0){      
      return false;  
    }
    input.val(ip);
  });
}

theme.checkProductCounter = function(counter,productMax) {
  var currentCount = parseInt($(counter).text());
  if(currentCount >= 0 && currentCount <= productMax) {    
    return true;
  }
}
theme.enableSubmitButtons = function() {
  var cartBtn = theme.selectors.$cartBtn;
  $(cartBtn).removeClass('full');
  //$(cartBtn).removeClass('disabled');
  $(cartBtn).attr("disabled", false);
}
theme.disableSubmitButtons = function() {
  var cartBtn = theme.selectors.$cartBtn;
  $(cartBtn).addClass('full');
  //$(cartBtn).addClass('disabled');
  $(cartBtn).attr("disabled", true);
}
$(theme.init);

$(document).ready(function () {
 // $('iframe#video1')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
 // let times = 0, playY;
  // $('body').on("click" , ".play-vid" , function(e){
  //   e.preventDefault();
  //   var value = $(this).attr('data-click');  
  //   if(value == 0){
  //     $(this).css("opacity", "0");   
  //     $(this).attr('data-click' ,'1');
  //     $(this).parents('.material-images').find('img').css("opacity", "0");
  //   }
  //   else{
  //     $(this).css("opacity", "1"); 
  //     $(this).attr('data-click' ,'0');        
  //     $(this).parents('.material-images').find('img').css("opacity", "1");
      
  //     }
  // });

  
// $('#video1').hide();
//    $('body').on("click" , ".play-vid" , function(e){
//      alert('00');
//      $('.video_image').hide();
//      $('#video1').show();
//    })

$('body').on("click" , ".learn-more ,.arrow" , function(e){
  var value = $(this).attr('data-click');
  if( value == 0){
   $(this).attr('data-click' ,'1');
   $(this).parents('.wrp_sub').find('p').show();
   $(this).parents().find('section').addClass('active')
  }
  else{
   $(this).attr('data-click' ,'0');
   $(this).parents('.wrp_sub').find('p').hide();
   $(this).parents().find('section').removeClass('active')
  }
});
})
